import React, { useEffect, useState } from 'react'

import { getThemeBuilderHostApp } from 'constants/jurisdictionConfigs'

import { Theme, createTheme } from '@platform-ui-kit/components-library'
import '@platform-ui-kit/components-library/dist/collection/global.css'
import '@platform-ui-kit/components-library/dist/platform-ui-kit/wpp-theme.css'
import { ComponentsPreview } from 'pages/ComponentsPreview/ComponentsPreview'
import { DataVisualizationPreview } from 'pages/DataVisualizationPreview/DataVisualizationPreview'
import { FormPreview } from 'pages/FormPreview/FormPreview'
import { HomePreview } from 'pages/HomePreview/HomePreview'
import { TablePreview } from 'pages/TablePreview/TablePreview'
import { loadStyleSheet } from 'pages/utils'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import './App.css'

const RoutesList = () => {
  const [theme, setTheme] = useState<Theme>()

  useEffect(() => {
    // Set up handler to receive the token from parent and announce parent that
    // the app is ready to receive the token.
    const hostAppURL = getThemeBuilderHostApp()

    const handler = (event: MessageEvent<any>) => {
      if (event.data?.themeData && event.data?.type === 'THEME_DATA' && event.origin === hostAppURL) {
        loadStyleSheet(event.data?.themeData?.settings?.fontUrl, () => setTheme(event.data?.themeData))
      }
    }

    window.addEventListener('message', handler)

    if (hostAppURL) {
      window.parent.postMessage({ type: 'IFRAME_APP_READY' }, hostAppURL)
    }

    return () => {
      window.removeEventListener('message', handler)
    }
  }, [])

  const themeStyles = theme && Object.keys(theme).length ? createTheme(theme) : {}

  return (
    <div style={themeStyles}>
      <Routes>
        <Route path="home" element={<HomePreview />} />
        <Route path="data-viz" element={<DataVisualizationPreview />} />
        <Route path="components" element={<ComponentsPreview />} />
        <Route path="table" element={<TablePreview />} />
        <Route path="form" element={<FormPreview />} />
      </Routes>
    </div>
  )
}

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <RoutesList />
    </BrowserRouter>
  )
}

export default App
